export const makeArray = (obj: any): any[] => {
  if (obj !== undefined && obj !== null) {

    const arr = Object.keys(obj).map((e: any) => {
      return {
        ...obj[e],
        sigla: e,
        sigla2: obj[e]?.sigla,
      }
    })

    return arr
  }
  return []
}

export const makePercent = (heigth: any, father: any): number => {
  const result = (100 * heigth) / father;
  return result;
}
export const makeSimplePercent = (value: number) => {
  return (value * 100) / 27;
}
export const MakeColorOpacity = (value: number): number => {
  if (value > 0.6 && value <= 0.7) {
    value = (value * 0.6) + value
  }

  if (value > 0.7) {
    value = (value * 0.9) + value
  }

  return (0.2 * 1) / value
}

export const makePosition = (value: number) => {
  if (value > 1) {
    return `${value} posições`
  }

  if (value < - 1) {
    return `${value} posições`
  }
  return `${value} posição `
}

export const makeVirgula = (value: number) => {
  const valueString = String(value);
  if (Number.isInteger(value)) {
    return valueString.concat(',0');
  }
  return valueString.split('.').join(',');
};

export const makeSort = (data: any[], orderBy: string, order: string = 'asc') => {
  if(order == 'asc'){
    data?.sort((a: any, b: any) => {
      if (a[orderBy] > b[orderBy]) {
        return 1
      }
  
      if (a[orderBy] < b[orderBy]) {
        return -1
      }
      return 0
    })
  }else{
    data?.sort((a: any, b: any) => {
      if (a[orderBy] > b[orderBy]) {
        return -1
      }
  
      if (a[orderBy] < b[orderBy]) {
        return 1
      }
      return 0
    })
  }


  return data as any;
}


export const inFive = (value: number) => {
  const find = [1, 6, 11, 16, 21, 27].find((e) => e === value)

  return find !== undefined
}

export const makeColorThermomether = (value: number) => {
    if(value <= 5){
      return '#4DB59A'
    }
    if(value <= 10){
      return ' #91C15E'
    }
    if(value <= 15){
      return '#F6DB6B'
    }
    if(value <= 20){
      return '#F59F25'
    }
    if(value <= 27){
      return '#E0494A'
    }

}

export const makeColorGanddi = (value: number) => {
  if(value == 0){
    return '#EABF6A'
  }
  if(value < 0){
    return '#E0494A'
  }
  
  if(value > 0){
    return '#4DB59A'
  }
  
}